import React, { useState } from "react";
import RadioButtonQuest from '../../../UI/RadioButtonQuest';
import GtmDataLayer from "../../../../Utility/GtmDataLayer";

const BlameLender = ({ clsName, onSelectAnswer, setBckFrmQ108, backClick }) => {

    const optionHandle = async (e) => {
        setBckFrmQ108(e.target.value);
        onSelectAnswer(e);
    }

    return (
        <>
            <div className={`qsSlider slidea1 ${clsName}`}>
                <h2 className="qs-title slide-up-now">
                    If you did blame the lender rather than yourself for the unaffordable lending, did this
                    blame occur within 3 years?
                </h2>
                <div className="btn-option optinal-items singleqs slide-up-now">
                    <div className=" option_but mb-3">
                        <RadioButtonQuest
                            key="bl1"
                            className="radio"
                            labelName="Yes"
                            onClick={optionHandle}
                            value="384"
                            name="blamelender"
                            id="bl1"
                            dataQuestId={125}
                            dataAnsId={384}
                            dataAnsLabel="Yes"
                        />
                    </div>
                    <div className=" option_but  mb-3">
                        <RadioButtonQuest
                            key="bl2"
                            className="radio"
                            labelName="No"
                            onClick={optionHandle}
                            value="385"
                            name="blamelender"
                            id="bl2"
                            dataQuestId={125}
                            dataAnsId={385}
                            dataAnsLabel="No"
                        />
                    </div>
                </div>
                <div className="mt-2 mb-5 text-center">
                    <div>
                        {" "}
                        <button type="button" className="back-btn mainbckBtn bi bi-chevron-left" id="back02" name="whomresponsible" onClick={backClick}>
                            Back
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlameLender;
